module.exports = __webpack_public_path__ + "img/PS29.fcd3706f.png";